import { apiFetch } from "./client";
import type { Page, Permission } from "./types";
import type { ListParams } from "./customers";

export async function listPermissions(params: ListParams = {}): Promise<Page<Permission>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/permissions${query ? `?${query}` : ""}`);
}
